import { inject as service } from '@ember/service';
import Component from '@glimmer/component';
import { action } from '@ember/object';
import { tracked } from '@glimmer/tracking';

import FunctionalUtils from 'mewe/shared/functional-utils';
import dispatcher from 'mewe/dispatcher';

export default class MwSmartSearchPage extends Component {
  @service router;

  @tracked isFollowingInProgress = false;
  @tracked justFollowed = false;

  get showFollowToggleButton() {
    if (this.args.page.isBanned) return false;
    return !this.args.page.isFollower || this.justFollowed;
  }

  @action
  goToPage() {
    this.router.transitionTo('app.publicid', this.args.page.publicLinkId);
  }

  @action
  toggleFollow(e) {
    e?.stopPropagation();

    this.isFollowingInProgress = true;

    const page = this.args.page;

    dispatcher.dispatch('pages', 'toggleFollow', page,
      { setToFollow: !page.isFollower,
        doneCb: () => {
          this.justFollowed = page.isFollower;

          if (page.isFollower) {
            FunctionalUtils.info(__('You are now following {name}', { name: page.name }));
          } else {
            FunctionalUtils.info(__('You are no longer following {name}', { name: page.name }));
          }
        },
        alwaysCb: () => this.isFollowingInProgress = false,
      }
    );
  }
}
